import * as BlockchainType from '@store/blockchain/type'

/**
 * blockchain store init state
 */
export const initBlockchainState: BlockchainType.BlockchainState = {
  balance: null,
}
